<ip-shared-loading-bar></ip-shared-loading-bar>
<p-toast></p-toast>
<router-outlet></router-outlet>
